import {availableStates} from '@/helpers/availableStates'

export default function () {
  return {
    success: null,
    error: null,
    availableStates,
    boardingPlace: {
      title: '',
      city: '',
      state: 'SP',
      latitude: null,
      longitude: null
    },
    errors: {
      title: null,
      city: null,
      state: null,
      latidude: null,
      longitude: null,
    }
  }
}
